import { UseInteractionsReturn } from '@floating-ui/react'
import { createContext, useContext } from 'react'
import { TSizeAll } from 'src/types'

export interface SelectContextValue {
  activeIndex: number | null
  selectedIndexes: number[]
  getItemProps?: UseInteractionsReturn['getItemProps']
  handleSelect: (index: number) => void
  size: TSizeAll
}

export const SelectContext = createContext<SelectContextValue | null>(null)

export const useSelectContext = () => {
  const context = useContext(SelectContext)
  if (!context) {
    throw new Error('useSelectContext must be used within a SelectContextProvider')
  }
  return context
}
